// Extends From
import Route from '@ember/routing/route';
// Ember Imports
import { service } from '@ember/service';

export default class CallbackRoute extends Route {
  @service
  router;

  @service
  session;

  // OAuth2 callbacks are handled in the application route. This is just a stub
  // so ember treats the route as valid.

  beforeModel() {
    // If this is running it means we have already authenticated the app but
    // some idiot pasted a callback url into their browser after already logging
    // in. Just transition to home.
    this.router.transitionTo('home');
  }
}
